import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Link,
} from '@mui/material';
import { LockReset } from '@mui/icons-material';
import { authAPI } from '../../services/api';
import Signature from '../../components/Signature';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await authAPI.forgotPassword(email.trim());
      setSent(response.data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Impossible de contacter le serveur. Réessayez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <LockReset color="primary" sx={{ fontSize: 48 }} />
            <Typography component="h1" variant="h5" fontWeight="bold" gutterBottom>
              Mot de passe oublié
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Entrez l'email de votre compte. Vous recevrez un lien pour choisir un nouveau mot de passe.
            </Typography>
          </Box>

          {sent ? (
            <Alert severity="success" sx={{ mt: 2 }}>
              {sent}
            </Alert>
          ) : (
            <Box component="form" onSubmit={handleSubmit}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
              <TextField
                margin="normal"
                required
                fullWidth
                label="Adresse email"
                type="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{ mt: 2 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Envoyer le lien'}
              </Button>
            </Box>
          )}

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Link component={RouterLink} to="/" variant="body2">
              ← Retour à la connexion
            </Link>
          </Box>
        </Paper>
      </Box>
      <Signature sx={{ mt: 4 }} />
    </Container>
  );
};

export default ForgotPassword;
